import type { PageRouterItem } from "@/utils/config";
import mitt from "mitt";

// 定义事件类型
type Events = {
	jumpTo: PageRouterItem;
};

// 创建全局事件总线实例
const emitter = mitt<Events>();

export default defineNuxtPlugin(() => {
	return {
		provide: {
			eventBus: {
				emit: emitter.emit,
				on: emitter.on,
				off: emitter.off,
			},
		},
	};
});
